import { render, staticRenderFns } from "./closure-object.vue?vue&type=template&id=09e5641e"
import script from "./closure-object.vue?vue&type=script&lang=js"
export * from "./closure-object.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports